import { OrderStatus } from '../../shared/enums';
import { OrderNumber } from '../../shared/types';
import { PublicCheckoutOrderPaymentMethod } from './public-checkout-order-payment-method';
import { Nillable } from '@web/utils';

export class PublicCheckoutOrderDetails {
  public constructor(
    private readonly data: {
      number: OrderNumber;
      status: OrderStatus;
      totalPrice: number;
      paymentMethod: PublicCheckoutOrderPaymentMethod;
      redirectUrl: Nillable<string>;
    },
  ) {}

  public get number(): OrderNumber {
    return this.data.number;
  }

  public get status(): OrderStatus {
    return this.data.status;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get paymentMethod(): PublicCheckoutOrderPaymentMethod {
    return this.data.paymentMethod;
  }

  public get redirectUrl(): Nillable<string> {
    return this.data.redirectUrl;
  }

  public isNew(): boolean {
    return this.status === OrderStatus.New;
  }

  public isPending(): boolean {
    return this.status === OrderStatus.Pending;
  }

  public isWaitingForPayment(): boolean {
    return this.status === OrderStatus.WaitingForPayment;
  }
}
